
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/staff-directory",
      function () {
        return require("private-next-pages/about/staff-directory.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/staff-directory"])
      });
    }
  